/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = '/pricing-settings'

const PricingSettingEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
  ({
    fetchPricingSetting: builder.query<any, void>({
      query: () => `${basePath}`,
      providesTags: ['pricingSettings']
    }),

    updatePricingSetting: builder.mutation<any, { expressPricePerKg: number; normalPricePerKg: number }>({
      query: (body) => ({
        url: `${basePath}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['pricingSettings']
    }),
  })

export default PricingSettingEndpoints
